import gql from "graphql-tag";

const typeDefs = gql`
  extend type Query {
    isLoggedIn: Boolean!
    startDate: String!
    endDate: String!
    storeSeletected: String!
    heatmapData(startDate: String!, endDate: String!): [[Int]]!
  }

  extend type Mutation {
    setDates(startDate: String, endDate: String): Dates
  }
`;

export default typeDefs;

//
